angular
  .module 'memberPortal'
  .directive 'memberPortalHeader', (
    $rootScope,
    $stateParams,
    $state,
    $http,
    $window,
    DataService
  ) ->
    restrict: 'EA'
    template: require('templates/member_portal/member_portal_header.html.slim')
    link: ($scope) ->
      $scope.data = DataService
      $scope.member = DataService.member_details

      $rootScope.$on '$stateChangeStart', (event, toState, toParams) ->
        $scope.isSidebarOpen = false
        $scope.title = toState.data?.title

      $scope.logout = ->
        url = "/websites/#{DataService.domain}/members/logout"
        $http.delete(url).then (response) ->
          url = $state.href('memberPortal.loginByHash', hash: response.data.login_hash)
          $window.location = url
          true
        , ->
          url = $state.href('memberPortal.loginByEmail')
          $window.location = url
          true

      $scope.getHash = ->
        $stateParams.hash || $stateParams.m

      $scope.toggleSidebar = ->
        $scope.isSidebarOpen = !$scope.isSidebarOpen
